import { useContext } from "react";
import * as React from 'react';
export var AvailableEntitiesContext = React.createContext([]);
export var AvailableEntitiesProvider = AvailableEntitiesContext.Provider;
export var useAvailableEntities = function () {
  return useContext(AvailableEntitiesContext) || [];
};